import React from "react";
import styles from "./Footer.module.scss";

export default function Footer({ noBackground = false }) {
  return (
    <div
      id="footer"
      className={
        styles.wrapper + " " + `${noBackground ? styles.noBackground : null}`
      }
    >
      <a target={"_blank"} href="https://iindy.co/terms">
        Terms & conditions
      </a>
      <a target={"_blank"} href="https://iindy.co/privacy">
        Privacy policy
      </a>
    </div>
  );
}
